/* eslint no-unused-vars: 0 */

/**
 * This file was automatically generated by ruby_to_typescript.rake.
 * Do not modify it by hand.
 */
export enum SolutionListingType {
  TECHNOLOGY_PRODUCT = "technology_product",
  SERVICE_OTHER = "service_other",
}
